import { detailAction } from '../actions/fetchdetail'
import { detailMutation } from '../mutations/fetchdetail'

export const detail = {
  state: {
    'manage/variable': {
      data: {}
    },
    'loan/myorderdetail': {
      data: {}
    },
  },
  mutations: detailMutation,
  actions: detailAction
}
